<template>
	<!-- <div class="row marg my-5">
		<div v-for="user in getUsers" :key="user" class="col-md-3">
			<div class="flip mt-5 text-info">
				<div
					class="card"
					role="button"
					:class="{ flipped: flip === user.id }"
					@click="flipcard(user.id)"
					style="background-color: #263238"
				>
					<div class="face front">
						<div class="inner card-header">
							<h5>{{ user.firstName }} {{ user.lastName }}</h5>
						</div>
						<h1 class="mt-5">{{ user.team }}</h1>
						<h1>{{ user.number }}</h1>
					</div>
					<div class="face back">
						<div class="inner text-center px-2">
							<h4>Stats</h4>
							<h5>#{{ user.number }}</h5>
							<span class="border-bottom border-info">Positions</span>
							<p class="mt-2">
								<small v-for="(pos, index) in user.positions" :key="pos">
									{{ pos }}<span v-if="index != user.positions.length - 1">, </span>
								</small>
							</p>
							<div v-for="s in userStats(user.id)" :key="s.stats">
								<div class="row text-center px-2">
									<div class="col-4">
										<span class="border-bottom border-info">Avg</span> {{ s.BA.substring(1) }}
									</div>
									<div class="col-4">
										<span class="border-bottom border-info">OBP</span> {{ s.OBP.substring(1) }}
									</div>
									<div class="col-4">
										<span class="border-bottom border-info">SLG</span> {{ s.SLG.substring(1) }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div> -->
	<h1 class="text-info mt-5">{{ year }} {{ getUserTeam }}</h1>
	<div class="marg">
		<div class="row mt-5">
			<div v-for="user in getUsers" :key="user" class="card col-lg-3 text-info">
				<div class="image p-4 border-radius">
					<div class="card-header">
						<h5>{{ user.firstName }} {{ user.lastName }}</h5>
					</div>
					<h1 class="mt-5">{{ user.team }}</h1>
					<h1 v-if="user.number">{{ user.number }}</h1>
					<h1 v-else>00</h1>

				</div>
				<div class="content">
					<h4>Stats</h4>
					<!-- <h5>#{{ user.number }}</h5> -->
					<p class="mt-2 text-start">
						<span class="me-3">Positions:</span>
						<small v-for="(pos, index) in user.positions" :key="pos">
							{{ pos }}<span v-if="index != user.positions.length - 1">, </span>
						</small>
					</p>
					<div v-for="s in userStats(user.id)" :key="s.stats" class="text-start">
						<div class=""><span >Avg:</span> {{ s.BA.substring(1) }}</div>
						<div class=""><span >OBP:</span> {{ s.OBP.substring(1) }}</div>
						<div class=""><span >SLG:</span> {{ s.SLG.substring(1) }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
moment().format();
export default {
	data() {
		return {
			flip: null,
		};
	},
	created() {
		this.loadUsers();
	},
	computed: {
		getUsers() {
			const users = this.$store.getters.allUsers;
			const filteredUsers = users.filter((i) => i.userType !== 'League Manager');
			const loggedUser = this.$store.getters.userTeam;
			this.players = filteredUsers;
			return filteredUsers
				.filter((user) => user.team === loggedUser)
				.sort((a, b) => {
					if (a.lastName < b.lastName) return -1;
					if (a.lastName > b.lastName) return 1;
				});
		},
		getUserTeam() {
			return this.$store.getters.userTeam
		},
		year() {
			return moment().year()
		}
	},
	methods: {
		flipcard(id) {
			if (this.flip === id) {
				this.flip = null;
			} else {
				this.flip = id;
			}
		},
		userStats(id) {
			const statsArr = [];
			for (let i = 0; i < this.getUsers.length; i++) {
				if (this.getUsers[i].stats !== undefined && this.getUsers[i].id === id) {
					statsArr.push(this.getUsers[i]);
				}
			}
			const userStatsArr = statsArr.map((i) => {
				return {
					...i,
					BA: (
						(i.stats.singles + i.stats.doubles + i.stats.triples + i.stats.homeruns) /
						i.stats.atBats
					).toFixed(3),
					OBP: (
						(i.stats.singles +
							i.stats.doubles +
							i.stats.triples +
							i.stats.homeruns +
							i.stats.walks +
							i.stats.hbp) /
						(i.stats.atBats + i.stats.walks + i.stats.hbp + i.stats.sf)
					).toFixed(3),
					SLG: (
						(i.stats.singles + 2 * i.stats.doubles + 3 * i.stats.triples + 4 * i.stats.homeruns) /
						i.stats.atBats
					).toFixed(3),
				};
			});
			return userStatsArr;
		},
		async loadUsers() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('fetchUsers');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
	},
};
</script>

<style scoped>
.marg {
	margin-top: 5rem;
	margin-left: 2rem;
}

.flip {
	-webkit-perspective: 800;
	perspective: 800;
	position: relative;
	text-align: center;
	/* margin-left: 4rem; */
}
.flip .card.flipped {
	-webkit-transform: rotatey(-180deg);
	transform: rotatey(-180deg);
}
.flip .card {
	width: 270px;
	height: 400px;
	-webkit-transform-style: preserve-3d;
	-webkit-transition: 0.5s;
	transform-style: preserve-3d;
	transition: 0.5s;
	background-color: #fff;
}
.flip .card .face {
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
	z-index: 2;
}
.flip .card .front {
	position: absolute;
	width: 270px;
	z-index: 1;
}
.flip .card .front img {
	width: 270px;
	height: 100%;
}
.flip .card .back {
	-webkit-transform: rotatey(-180deg);
	transform: rotatey(-180deg);
	position: absolute;
}
.inner {
	margin: 0px !important;
	width: 270px;
}
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}
/* .container {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	padding: 30px;
} */

 .card {
	position: relative;
	max-width: 300px;
	height: 215px;
	background-color: #12171a;
	margin: 30px 10px;
	padding: 20px 15px;

	display: flex;
	flex-direction: column;
	box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
	transition: 0.3s ease-in-out;
	border-radius: 15px;
}
 .card:hover {
	height: 320px;
}

 .card .image {
	position: relative;
	width: 260px;
	height: 400px;
	background-color: #263238;
	border-radius: 15px;
	top: -40%;
	left: 8px;
	box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
	z-index: 1;
}

 .card .image img {
	max-width: 100%;
	border-radius: 15px;
}

 .card .content {
	position: relative;
	top: -140px;
	padding: 10px 15px;
	text-align: center;
	background-color: #12171a;
	visibility: hidden;
	opacity: 0;
	transition: 0.3s ease-in-out;
}

 .card:hover .content {
	margin-top: 30px;
	visibility: visible;
	opacity: 1;
	transition-delay: 0.2s;
}
</style>
